<template>
  <artmisads-modal v-model:open="visible" :title="showUpload ? '上传CSV表查询ASIN数据' : '查询结果'" :footer="null" width="800px"
    @cancel="handleClose">
    <a-spin :spinning="uploading">
      <div class="upload-model" v-if="showUpload">
        <div>
          <h4 style="font-weight: bolder;margin: 16px 0;">
            Marketplace
          </h4>
          <div ref="marketplaceRef">
            <artmisads-select style="width: 232px" v-model:value="marketplace"
              :getPopupContainer="() => $refs.marketplaceRef" :options="COUNTRY_BASE_OPTIONS" />
          </div>
        </div>
        <div class="file-name" v-if="fileName">
          <div>
            <svg class="icon icon-biaoge" aria-hidden="true">
              <use xlink:href="#icon-biaoge"></use>
            </svg>
            <span class="name">{{ fileName }}</span>
            <svg class="icon close-cu" aria-hidden="true" @click="clearFile">
              <use xlink:href="#icon-close-cu"></use>
            </svg>
          </div>
        </div>
        <a-upload name="avatar" list-type="picture-card" :show-upload-list="false" accept=".csv"
          :before-upload="beforeUpload" @change="handleChange" v-else>
          <p class="ant-upload-drag-icon">
            <inbox-outlined></inbox-outlined>
          </p>
          <svg class="icon shangchuan2" aria-hidden="true">
            <use xlink:href="#icon-jiahao-cu"></use>
          </svg>
          Choose a file...
        </a-upload>
        <div class="upload-text">

          <div class="footer">
            <div> </div>
            <artmisads-button type="primary" :loading="uploading" :disabled="!fileName" @click="handleUploadFile">
              查询
            </artmisads-button>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="list.length === 0 && !uploading" class="empty-state">
          <p>暂无数据</p>
        </div>
        <div v-else>
          <div style="margin-bottom: 16px;">
            <artmisads-button isSquare="true" @click="reset" :disabled="selectList.length === 0">爬虫重试</artmisads-button>
          </div>
          <artmisads-table :scroll="{ x: 2200, y: tableScrollHeight }" :columns="columns" :data-source="list"
            :row-selection="{
              selectedRowKeys: selectList,
              onChange: onSelectChange,
              getCheckboxProps: (record) => ({
                disabled: record.crawlerPrice == 'Failed' ? false : true
              })
            }" row-key="asin" :pagination="null" :row-key="(record, index) => index" />
          <div class="foot-btn">
            <artmisads-button type="primary" isSquare="true" @click="exData">导出数据</artmisads-button>
          </div>
        </div>

      </div>
    </a-spin>
  </artmisads-modal>
</template>

<script setup>
import { ref, watch, defineExpose } from 'vue'
import { message } from 'ant-design-vue'
import { publisherAdminApi } from '~/server/index'
import moment from 'moment'

import { COUNTRY_BASE } from '~/contants/common'

const visible = ref(false)
const showUpload = ref(true)
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host
  item.label = item.host
  return item
})

const selectList = ref([])
const marketplace = ref('amazon.com')
const list = ref([])
const formData = ref(new FormData())

const emit = defineEmits(['update:open', 'success'])
const fileName = ref('')
const uploading = ref(false)

// 表格列定义
const columns = ref([
  {
    title: 'ASIN',
    dataIndex: 'asin',
    key: 'asin',
    width: 120
  },
  {
    title: 'ProductID',
    dataIndex: 'productId',
    key: 'productId',
    width: 120
  },
  {
    title: 'Brand',
    dataIndex: 'brand',
    key: 'brand',
    width: 120
  },
  {
    title: 'AmazonSellerName',
    dataIndex: 'amazonSellerName',
    key: 'amazonSellerName',
    width: 150
  },
  {
    title: 'AttributionStatus',
    dataIndex: 'attributionStatus',
    key: 'attributionStatus',
    width: 120
  },
  {
    title: 'AssociateStatus',
    dataIndex: 'associateStatus',
    key: 'associateStatus',
    width: 120
  },
  // {
  //   title: '所有折扣信息',
  //   dataIndex: 'discountInfo',
  //   key: 'discountInfo',
  //   width: 150
  // },
  {
    title: '爬虫Deal价格',
    dataIndex: 'crawlerPrice',
    key: 'crawlerPrice',
    width: 120
  },
  {
    title: '是否变体',
    dataIndex: 'isVariant',
    key: 'isVariant',
    width: 100
  }
])

// 分页配置
const pagination = ref({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  pageSizeOptions: ['10', '20', '50', '100']
})
const onSelectChange = (selectedRowKeys, selectedRows) => {

  selectList.value = selectedRowKeys
}
const reset = () => {
  const param = {
    marketplace: marketplace.value,
    asins: selectList.value
  }
  uploading.value = true
  publisherAdminApi.dmSubmittedDealsManualAsinCrawlerRetry(param).then(res => {
    if (res.success) {
      message.success('刷新成功')
      list.value.forEach(item => {
        res.data.forEach(item2 => {
          if (item.asin === item2.asin) {
            item.crawlerPrice = item2.crawlerPrice
          }
        })
      })

      selectList.value = []
    }
  }).finally(() => {
    uploading.value = false
  })

}
const handleChange = async ({ file }) => {
  formData.value = new FormData()
  const { type, originFileObj, percent, name } = file
  if (percent === 100) {
    if (type !== 'text/csv') {
      return message.error('Please upload a csv file.')
    } else {
      fileName.value = name
      try {
        formData.value.append('file', originFileObj)
        formData.value.append('marketplace', marketplace.value)
      } catch (error) {
        message.error('Upload failed')
      }
    }
  }
}
const exData = () => {

  const newExportParams={
    rows:list.value
  }
   const finalParams = {
      qs: newExportParams,
      fileName: `所有折扣信息`,
      platform:'operator',
      method:'POST'
    }
    publisherAdminApi.dmSubmittedDealsManualAsinCsvExport(finalParams)
}
const beforeUpload = (file) => {
  const isCSV = file.type === 'text/csv' || file.name.endsWith('.csv')
  if (!isCSV) {
    message.error('You can only upload CSV file!')
    return false
  }
  const isLt10M = file.size / 1024 / 1024 < 10
  if (!isLt10M) {
    message.error('File size exceeds 10MB')
    return false
  }
  return true
}
const clearFile = () => {
  fileName.value = ''
  formData.value = new FormData()
  list.value = []
  // props.setDataList({ successList: [], failList: [] });
}


const handleUploadFile = async () => {
  uploading.value = true
  let res = await publisherAdminApi.dmSubmittedDealsManualAsinCsvQuery(formData.value)
  const { success, error, data } = res
  if (success) {
    showUpload.value = false
    list.value = res.data
    pagination.value.total = res.data.length
  } else {
    message.error("File upload failed")
  }
  uploading.value = false
}
const open = () => {
  showUpload.value = true
  clearFile()
  visible.value = true
}
defineExpose({
  open,
})
const handleClose = () => {

  fileName.value = ''
  list.value = []
}
</script>

<style lang="less" scoped>
.foot-btn {
  display: flex;
  justify-content: center;
}

.upload-model {
  .top-content {
    margin-bottom: 16px;
  }

  .select-month {
    margin: 16px 0;
  }

  :deep(.ant-upload-wrapper) {
    margin-top: 8px !important;

    .ant-upload.ant-upload-select {
      width: 100%;
      height: 64px;
      color: var(--dark-2);
      background: var(--big-bg-1);
      border: 2px dashed var(--border-1);
      border-radius: 8px;
      font-size: var(--font-size-h-l);

      &:hover {
        background: var(--bg-gray-2);
        border: 2px dashed var(--bg-gray-7);
      }

      svg {
        width: 32px;
        height: 32px;
        fill: var(--dark-2);
        margin-right: 16px;
      }
    }
  }

  :deep(.ant-upload-wrapper) {
    margin-top: 16px;

    .ant-upload.ant-upload-select {
      width: 100%;
      height: 60px;
      color: var(--dark-2);
      background: var(--big-bg-1);
      border: 1px dashed var(--border-1);
      border-radius: 8px;
      font-size: var(--font-size-h-l);
      font-weight: 500;

      &:hover {
        background: var(--bg-gray-2);
        border: 1px dashed var(--bg-gray-7);
      }

      svg {
        width: 24px;
        height: 24px;
        fill: var(--dark-2);
        margin-right: 8px;
      }
    }
  }

  .file-name {
    display: flex;
    width: 100%;
    height: 60px;
    cursor: pointer;
    background: var(--big-bg-1);
    border-radius: 8px;
    color: var(--dark-2);
    margin-top: 8px;

    &:hover {
      background: var(--bg-gray-2);
    }

    >div {
      display: flex;
      height: 28px;
      padding: 0 24px;
      border-radius: 8px;
      align-self: center;

      // &:hover {
      //   background-color: var(--bg-gray-4);
      // }
      .icon-biaoge {
        width: 24px;
        height: 24px;
        fill: var(--primary-text);
        align-self: center;
      }

      .name {
        color: var(--primary-text);
        font-weight: 500;
        font-size: 16px;
        letter-spacing: 0.4px;
        line-height: 22px;
        margin-left: 8px;
        margin-right: 24px;
        align-self: center;
      }

      .close-cu {
        cursor: pointer;
        width: 24px;
        height: 24px;
        padding: 4px;
        align-self: center;
        fill: var(--dark-3);

        &:hover {
          fill: var(--dark-1);
        }
      }
    }

  }

  .notice {
    padding: 12px;
    margin-bottom: 16px;
    background: var(--bg-gray-1);
    border-radius: 8px;

    p {
      margin: 0;
      color: var(--dark-2);
      line-height: 20px;

      span {
        color: var(--dark-1);
        font-weight: 500;
      }
    }
  }

  .upload-area {
    padding: 24px;
    background: var(--bg-gray-1);
    border-radius: 8px;
    text-align: center;

    :deep(.ant-upload-list) {
      text-align: left;
      margin-top: 16px;
    }
  }

  .upload-text {
    margin: 8px 0 0;
    color: var(--dark-2);
    font-size: 12px;
    display: flex;
    align-items: center;

  }


}

.footer {
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}


.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: var(--dark-3);
  font-size: 14px;
}
</style>